import { makeStyles } from '@mui/styles';

const useListItemStyles = makeStyles({
	margin: {
		marginTop: 12,
	},
	title: {
		color: 'rgba(0, 0, 0, 0.6)',
		display: 'block',
		fontFamily: 'Montserrat',
		fontSize: 14,
	},
	value: {
		color: '#1A1233',
		display: 'block',
		fontFamily: 'Montserrat',
		fontSize: 12,
		fontWeight: 600,
		maxWidth: '100%',
		textOverflow: 'ellipsis',
	},
});

export default useListItemStyles;
